import React from "react";
import "../styles/Experties.css";
import Expert1 from "../assets/1.png";
import Expert2 from "../assets/2.png";
import Expert3 from "../assets/3.png";
import Expert4 from "../assets/4.png";

const Experties = () => {
  return (
    <div className="row-container">
      <div className="column13">
        <img src={Expert1} alt="Expert Icon" className="icon123" />
        <h2 className="heading">Excellent Support</h2>
        <p className="paragraph">
          From troubleshooting technical issues to providing creative guidance,
          we're here to ensure your artistic journey is smooth and enjoyable.
        </p>
      </div>
      <div className="column13">
        <img src={Expert2} alt="Expert Icon" className="icon12" />
        <h2 className="heading">Reliable Expert</h2>
        <p className="paragraph">
          Our team is passionate about pushing the boundaries of creative
          technology, and we're dedicated to providing you with the best
          possible experience.
        </p>
      </div>
      <div className="column13">
        <img src={Expert3} alt="Expert Icon" className="icon12" />
        <h2 className="heading">Cutting-Edge Technology</h2>
        <p className="paragraph">
          Experience the power of advanced AI algorithms that deliver
          exceptional image quality and artistic style. Our technology pushes
          the boundaries of what's possible in AI art generation.
        </p>
      </div>
      <div className="column13">
        <img src={Expert4} alt="Expert Icon" className="icon12" />
        <h2 className="heading">Rapid Image Generation</h2>
        <p className="paragraph">
          Don't let inspiration wait. Our AI works efficiently to produce
          high-quality images in a matter of seconds, allowing you to iterate
          and refine your ideas quickly.
        </p>
      </div>
    </div>
  );
};

export default Experties;
